import { render } from "./auto-release.vue?vue&type=template&id=28f3d7e0"
const script = {}

import exportComponent from "/working_dir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__